import { gsap, Power2 }   from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { ScrollTrigger }  from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

ScrollTrigger.create({
	start: 'top top',
	end: 'bottom bottom',
	onUpdate: ({ progress, direction, isActive }) =>
	{
		gsap.to('#progress span', {
			width: progress * 100 + '%',
		})
	}
})
